module.exports = __webpack_public_path__ + "static/media/terms_en.5f1cf906.txt";